import { render, staticRenderFns } from "./DownloadMoreOptions.vue?vue&type=template&id=14751f67&scoped=true&"
import script from "./DownloadMoreOptions.vue?vue&type=script&lang=js&"
export * from "./DownloadMoreOptions.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMoreOptions.vue?vue&type=style&index=0&id=14751f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14751f67",
  null
  
)

export default component.exports